import { addDays } from "date-fns";
import { UseFormReturn, useWatch } from "react-hook-form";

import { useTranslation } from "../../core/translation.core";
import { DateOption, OrderListFilter } from "../../types/order";
import { LabelAndInput } from "../reuseables/form.comp";

export default function DateRangePicker({ methods }: { methods: UseFormReturn<any, any> }) {
  const { t, msg } = useTranslation();

  return (
    <div className="flex justify-between gap-4">
      <DateRangeBtns methods={methods} />
      <div>
        <LabelAndInput label={t(msg.date.fromDate)} type="date" register={methods.register} fieldName="date.from" />
        <LabelAndInput label={t(msg.date.toDate)} type="date" register={methods.register} fieldName="date.to" />
      </div>
    </div>
  );
}

function DateRangeBtns({ methods }: { methods: UseFormReturn<OrderListFilter, any> }) {
  const { t, msg } = useTranslation();
  const dateOption = useWatch({ name: "dateOption", control: methods.control });

  function setDate(dateOption: DateOption, from: Date, to: Date) {
    methods.setValue("dateOption", dateOption);
  }

  return (
    <div className="flex flex-wrap flex-col mt-4 items-start">
      <button
        type="button"
        className={`${dateOption === "today" ? "font-bold" : "underline"} `}
        onClick={() => setDate("today", new Date(), new Date())}
      >
        {t(msg.date.today)}
      </button>
      <button
        type="button"
        className={`${dateOption === "last7Days" ? "font-bold" : "underline"} `}
        onClick={() => setDate("last7Days", addDays(new Date(), -7), new Date())}
      >
        {t(msg.date.last7Days)}
      </button>
      <button
        type="button"
        className={`${dateOption === "last30Days" ? "font-bold" : "underline"} `}
        onClick={() => setDate("last30Days", addDays(new Date(), -30), new Date())}
      >
        {t(msg.date.last30Days)}
      </button>
      <button
        type="button"
        className={`${dateOption === "last365Days" ? "font-bold" : "underline"} `}
        onClick={() => setDate("last365Days", addDays(new Date(), -365), new Date())}
      >
        {t(msg.date.last365Days)}
      </button>
      {/* <button type="button" className="underline mt-2" onClick={() => setDate(startOfWeek(new Date()), new Date())}>
        {t(msg.date.thisWeek)}
      </button>
      <button type="button" className="underline" onClick={() => setDate(startOfMonth(new Date()), new Date())}>
        {t(msg.date.thisMonth)}
      </button>
      <button type="button" className="underline" onClick={() => setDate(startOfYear(new Date()), new Date())}>
        {t(msg.date.ytd)}
      </button> */}
    </div>
  );
}
